<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    

    <!-- Sección de Actividades -->
    <div class="carousel-section">
      <header class="section-header section-header-activities mb-3">
        <h3 class="text-transparencia">
          ACTIVIDADES
        </h3>
        <hr style="border-top-color: rgba(0, 0, 0, 0.15) !important;" />
      </header>

      <div id="slider-actividades">
        <template v-for="(actividad, index) in actividades">
          <div class="pl-2 pr-2" :key="index">
            <div class="card card-frame card-owework border hover-shadow-9 transition-hover">
              <div class="card-img-top w-100 text-center">
                <a :href="'detalle/' + actividad.voluntariadoActividadId">
                  <img class="img-fluid w-100 rounded cimage-slider" :src="`${filesUrl}${actividad.rutaImagenMiniatura}`" :alt="actividad.titulo" />
                </a>
              </div>
              <div class="card-body p-2">
                <div class="d-flex justify-content-center text-center" style="height:6.6rem !important;overflow:hidden">
                  <a :href="'detalle/' + actividad.voluntariadoActividadId">
                    <h6 class="card-title fs-15 text-transparencia">{{ actividad.titulo }}</h6>
                  </a>
                </div>
              </div>
              <div class="card-footer text-right pt-0">
                <a class="fs-13 fw-600 anim-link-2 anim-link-2-primary" :href="'detalle/' + actividad.voluntariadoActividadId">Leer más<i class="fa fa-search-plus ml-1"></i></a>
              </div>
            </div>
          </div>
        </template>
      </div>
      
      <!-- Botón Ver todo -->
      <div class="text-center mt-4">
        <router-link to="/voluntariado/actividades/listar" class="btn btn-primary">
          Ver todo
        </router-link>
      </div>
    </div>

    <!-- Sección de Noticias -->
    <div class="carousel-section mt-7">
      <view-noticias-voluntariado></view-noticias-voluntariado>
    </div>

    <!-- Sección de Informes -->
    <div class="carousel-section mt-7">
      <view-informes-voluntariado></view-informes-voluntariado>
    </div>
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";
import viewNoticiasVoluntariado from "@/components/voluntariado/view-noticias-voluntariado";
import viewInformesVoluntariado from "@/components/voluntariado/view-informes-voluntariado";
export default {
  name: "voluntariado-actividades-carousel",
  metaInfo: {
    title: "Actividades de voluntariado",
  },
  components: {
    layoutBreadcrumb,
    viewNoticiasVoluntariado,
    viewInformesVoluntariado
  },
  data: () => ({
    actividades: [],
  }),
  methods: {
    fetchDatosActividades: function() {
      this.$http.get(this.apiRoute("Common", "ListVoluntariadoActividadesAll")).then(function(response) {
        if (!response.body.error) {
          this.actividades = response.body.data;
        }
        startSlider("slider-actividades", [4, 3, 3, 2, 2, 1]);
      });
    },
  },
  mounted: function() {
    this.fetchDatosActividades();

    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "/voluntariado", icon: "", active: false },
      { name: "Actividades", url: "", icon: "", active: true },
    ];
  },
};
</script>

<style scoped>
.carousel-section {
  margin-bottom: 2rem;
}

.section-header-activities {
  text-align: center;
}

.section-header-activities h3 {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
}

.section-header-activities hr {
  width: 60px;
  margin: 0 auto;
  border-top: 3px solid #2484da;
}

/* Estilos para el carrusel */
.slick-prev:before,
.slick-next:before {
  color: #2484da !important;
}

.slick-prev {
  left: -25px;
}

.slick-next {
  right: -25px;
}

/* Forzar layout horizontal desde el inicio para evitar apilamiento */
#slider-actividades {
  display: flex !important;
  overflow-x: hidden;
}

#slider-actividades .pl-2 {
  flex-shrink: 0;
  width: 25%; /* Para 4 elementos por fila */
}

/* Responsive */
@media (max-width: 768px) {
  .slick-prev,
  .slick-next {
    display: none !important;
  }
}
</style>
